import gql from 'graphql-tag';

export const TOGGLE_CALENDAR_VIEW = gql`
  mutation SaveCalendarViewConfiguration($input: ToggleCalendarViewVisibilityInput!) {
    dealActivity {
      result: toggleCalendarViewVisibility(input: $input) {
        error
        success
        entity {
          id
          isActive
        }
      }
    }
  }
`;
